export const poBoxRegex = /^box[^a-z]|(p[-. ]?o.?[- ]?|post office )b(.|ox)/i;
export const breakTagRegex = /<br\s*[/]?>/gi;
